import { useMutation } from '@tanstack/react-query';
import {
  invalidateWaitlistEntries,
  invalidateWaitlistEntry,
  manuallyNotifyCancellationWaitlistEntry,
} from '../../services/cancellation-waitlist';
import { ManualNotifyPayload } from '../../types/cancellation-waitlist';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: (message: string) => void | Promise<void>;
}

function useManuallyNotifyWaitlist({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: (payload: ManualNotifyPayload) =>
      manuallyNotifyCancellationWaitlistEntry(payload),
    onSuccess: async (_data, payload) => {
      await invalidateWaitlistEntries();
      await invalidateWaitlistEntry(payload.waitlistEntryId);
      await onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error.message || 'Failed to send the notification');
    },
  });
}

export default useManuallyNotifyWaitlist;
